import axios from "axios";
import { Message } from "element-ui";
import qs from "qs";
// create an axios instance
const service = axios.create({
  baseURL: "", // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 500000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    config.headers["Accept"] = "application/json";
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
service.interceptors.response.use((response) => {
  const { data } = response;
  const res = Object.assign(response.data, {
    msg: data.message || data.result_msg || data.msg,
  });
  if (res.code === 0) {
    // 接口成功
    return res;
  } else {
    Message({
      message: res.message || res.result_msg || res.msg || "Error",
      type: "error",
      duration: 5 * 1000,
    });
    return {};
  }
});
/**
 * get/post 表单提交
 * @param {*} url
 * @param {*} data
 */
service.getForm = (url, params) => {
  const options = {
    method: "GET",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
    params,
    url,
  };
  return service(options);
};

service.postForm = (url, data) => {
  const options = {
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
    data: qs.stringify(data),
    url,
  };
  return service(options);
};
export default service;
